module.exports = __webpack_public_path__ + "static/media/custom-5000-low.c3e6ee13.svg";